/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : '1',
        title: 'Trilhas do Sucesso',
        type : 'basic',
        icon : 'heroicons_outline:map-pin',
        link : '/academia-edduca'
    },
    {
        id   : '2',
        title: 'Aulas Ao Vivo',
        type : 'basic',
        icon : 'feather:youtube',
        link : '/aulas-ao-vivo'
    },
    {
        id   : '3',
        title: 'EdducAI',
        type : 'basic',
        icon : 'mat_outline:smart_toy',
        link : '/edducai'
    },
    {
        id   : '4',
        title: 'Ranking',
        type : 'basic',
        icon : 'heroicons_outline:star',
        link : '/ranking'
    },
    {
        id   : '5',
        title: 'Badges',
        type : 'basic',
        icon : 'heroicons_outline:trophy',
        link : '/badges'
    },
    {
        id   : '6',
        title: 'Certificados',
        type : 'basic',
        icon : 'feather:award',
        link : '/certificados'
    },
    {
        id   : '7',
        title: 'Feedbacks',
        type : 'basic',
        icon : 'feather:smile',
        link : '/feedbacks'
    },
    {
        id   : '8',
        title: 'Newsletter',
        type : 'basic',
        icon : 'heroicons_outline:newspaper',
        link : '/newsletter'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
